import { FragmentComponent } from '@/types/graphql'
import { DSGridSpacing, DSSpacer, DSText, DSTextVariantType } from '@zoe/ds-web'
import React from 'react'
import { processTypographyMarkdown } from '../DesignSystem/Typography'
import { DSGrid, DSGridBlock, GridSurfaceColour } from '@/components/ds/Grid/Grid'

export type FullWidthTextRecord = {
  __typename: 'FullWidthTextRecord'
  id: string
  text: string
  backgroundColor?: GridSurfaceColour
  variant?: DSTextVariantType
  spacing?: DSGridSpacing
  spacingMobile?: DSGridSpacing
}

const fragment = `
  fragment FullWidthTextBlockFragment on FullWidthTextRecord {
    __typename
    id
    text
    backgroundColor
    variant
    spacing
    spacingMobile
  }
`

export const FullWidthTextBlock: FragmentComponent<{}, FullWidthTextRecord> = ({ record }) => (
  <DSGrid
    backgroundFullWidth
    backgroundColor={record.backgroundColor || 'teal-subtle'}
    mobileBackgroundColor={record.backgroundColor || 'teal-subtle'}
  >
    <DSGridBlock
      breakConfig={{
        s: { colSpan: 2 },
        m: { colSpan: 6 },
        l: { colSpan: 6, offset: 3 },
        xl: { colSpan: 6, offset: 3 },
      }}
    >
      <DSSpacer
        direction="vertical"
        size={record?.spacing || 48}
        breakAt={{ m: record?.spacingMobile || record?.spacing || 24 }}
      />
      <DSText as="h3" variant={record.variant || 'fluid-heading-700'} align="center">
        {processTypographyMarkdown({ content: record.text, variant: record.variant || 'fluid-heading-700' })}
      </DSText>
      <DSSpacer
        direction="vertical"
        size={record?.spacing || 48}
        breakAt={{ m: record?.spacingMobile || record?.spacing || 24 }}
      />
    </DSGridBlock>
  </DSGrid>
)

FullWidthTextBlock.fragment = fragment
FullWidthTextBlock.recordName = 'FullWidthTextRecord'
